export const checks = [
  ['lichid_frana', 'Nivel lichid de frână'], ['parbriz_oglinzi', 'Parbriz / oglinzi'],
  ['stergatoare', 'Ștergătoare'], ['lumini', 'Lumini / semnalizare'], ['frane', 'Discuri / plăcuțe frână'],
  ['suspensie', 'Suspensie'], ['scurgeri', 'Scurgeri de fluide'], ['esapament', 'Eșapament'],
  ['climatizare', 'Climatizare'], ['anvelopa_sf', 'Anvelopă stânga față'], ['anvelopa_df', 'Anvelopă dreapta față'],
  ['anvelopa_ss', 'Anvelopă stânga spate'], ['anvelopa_ds', 'Anvelopă dreapta spate'],
  ['janta_sf', 'Jantă stânga față'], ['janta_df', 'Jantă dreapta față'],
  ['janta_ss', 'Jantă stânga spate'], ['janta_ds', 'Jantă dreapta spate'],
];
export const inventory = [
  ['cheie_antifurt', 'Cheie antifurt roți'], ['roata_rezerva', 'Roată de rezervă'],
  ['kit_pana', 'Kit de pană'], ['cablu_incarcare', 'Cablu de încărcare'],
  ['trusa', 'Trusă sanitară'], ['extinctor', 'Extinctor'], ['triunghi', 'Triunghi reflectorizant'],
  ['documente', 'Carnet întreținere / documente'],
];
export const checkStates = { neverificat: 'Neverificat', bun: 'Bun', interventie: 'Necesită intervenție', nu_se_aplica: 'Nu se aplică' };
export const inventoryStates = { neverificat: 'Neverificat', prezent: 'Prezent', absent: 'Absent', nu_se_aplica: 'Nu se aplică' };
export const zones = { fata: 'Față', spate: 'Spate', capota: 'Capotă', plafon: 'Plafon', portbagaj: 'Portbagaj',
  stanga_fata: 'Stânga față', stanga_spate: 'Stânga spate', dreapta_fata: 'Dreapta față', dreapta_spate: 'Dreapta spate', parbriz: 'Parbriz' };
export const damageTypes = { zgarietura: 'Zgârietură', deformare: 'Deformare', fisura: 'Fisură' };
